import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Image from 'gatsby-image';

import TagIcon from '../icons/TagIcon.svg';
import LocationIcon from '../icons/LocationIcon.svg';


const GridItem = ({ uid, sizes, alt, title, subtitle, date , words , category, location }) => (

    <div className="wrapper">
        <div className="blog-index__block" key={uid}>

            <div className="block-text">
                <div className="date">{date} · {words} words</div>

                <div className="row">
                    <Link to={uid}>
                        <div className="block-title"> {title} </div>
                    </Link>

                    <div className="block-tags">
                      <div className="category"><TagIcon className="icon"/> {category} </div>
                      <div className="category"> <LocationIcon className="icon"/> {location}</div>
                    </div>
                </div>

                <div className="block-image">
                    <Link to={uid}>
                    <Image sizes={sizes} alt={alt} />
                    </Link>
                </div>

                <div className="block-description">
                 {subtitle}
                </div>

                <div className="block-cta">
                 <Link to={uid}>
                    <div className="btn"> Read more</div>
                 </Link>
                </div>

             </div>

        </div>
    </div>


);

export default GridItem;

GridItem.propTypes = {
  uid: PropTypes.string.isRequired,
  sizes: PropTypes.any.isRequired,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  words: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/GridItem.jsx